var scope_0 = require('/home/forge/odds-prod.parallelpublicworks.com/odds-frontend/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c6a8fcd1ed8b7ad2fe90af8e66c8eb31.js').default;export default
        Object.assign({}, scope_0 )
    